import React from 'react';
import { findSourceColumnIndex, stripSemicolonsBeforeFirstCitation } from '../utils/citationDisplay';
import { parseMarkdownTableStructure } from '../utils/markdownTable';
import { MarkdownTableCell } from './MarkdownTableCell';

/**
 * GFM pipe table renderer for Answers / Assistants markdown.
 * @param {{
 *   tableLines: string[];
 *   tableKey: string;
 *   wrapClassName: string;
 *   tableClassName: string;
 *   renderCell: (cell: string, cellKey: string, meta?: { isSourceColumn?: boolean; dedupeCitations?: boolean }) => React.ReactNode;
 * }} props
 */
export function MarkdownTable({
  tableLines,
  tableKey,
  wrapClassName,
  tableClassName,
  renderCell,
}) {
  const { header, body } = parseMarkdownTableStructure(tableLines);
  const sourceColumnIndex = findSourceColumnIndex(header);

  const cellForRender = (cell, isSourceColumn) => (
    isSourceColumn ? stripSemicolonsBeforeFirstCitation(cell) : cell
  );

  return (
    <div key={tableKey} className={wrapClassName}>
      <table className={tableClassName}>
        {header && (
          <thead>
            <tr>
              {header.map((cell, cellIdx) => {
                const cellKey = `${tableKey}-h-${cellIdx}`;
                const isSourceColumn = cellIdx === sourceColumnIndex;
                return (
                  <MarkdownTableCell key={cellKey} as="th" cellText={cell}>
                    {renderCell(cell, cellKey, { isSourceColumn })}
                  </MarkdownTableCell>
                );
              })}
            </tr>
          </thead>
        )}
        <tbody>
          {body.map((row, rowIdx) => (
            <tr key={`${tableKey}-r-${rowIdx}`}>
              {row.map((cell, cellIdx) => {
                const cellKey = `${tableKey}-r-${rowIdx}-c-${cellIdx}`;
                const isSourceColumn = cellIdx === sourceColumnIndex;
                const displayCell = cellForRender(cell, isSourceColumn);
                return (
                  <MarkdownTableCell key={cellKey} as="td" cellText={displayCell}>
                    {renderCell(displayCell, cellKey, { isSourceColumn, dedupeCitations: true })}
                  </MarkdownTableCell>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
